import axios from "axios";
import { isValidIncident } from "src/lib/incident.helper";
import { type IncidentDto } from "src/types/incidentDto";

import axiosErrorHandler from "./apiError.handler";

const INCIDENTS_URL = "https://storage.googleapis.com/ase-public-files-storage/diamondapp/incidents.json";

export async function apiGetIncidents(): Promise<IncidentDto[]> {
  try {
    const { data } = await axios.get<{ incidents?: unknown }>(`${INCIDENTS_URL}?v=${Date.now()}`);
    return Array.isArray(data?.incidents) ? data.incidents.filter(isValidIncident) : [];
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while loading incidents");
  }
}